/* globals $ App Craft */

import { omitBy } from "lodash";
import { Collapsible } from "../collapsible";
import "jquery-serializejson";
import { ProviderWebsite } from "../provider-website";

export default class Results {
  constructor($elem) {
    this.page = 1;
    this.$elem = $elem;
    this.$list = this.$elem.find(".providers-list");
    this.$loadMore = this.$elem.find(".load-more");
    this.$loadMoreButton = this.$elem.find(".js-load-more");
    this.$form = this.$elem.find("form");
    this.$loader = this.$elem.find(".js-loader");
    this.$noResults = this.$elem.find(".no-results");
    this.$noFilters = this.$elem.find(".no-filters");
    this.$searchError = this.$elem.find(".search-error");
    new Collapsible(this.$elem);
    this.providerWebsites = new ProviderWebsite();
    this.$elem.find(".js-reset").click(() => {
      this.resetForm();
      this.loadProviders();
    });
    this.$form.submit((e) => {
      e.preventDefault();
      this.loadProviders();
    });
    this.$loadMoreButton.click((e) => {
      e.preventDefault();
      this.loadProviders(false, false, true);
    });
    this.$elem.find(".to-top").click((e) => {
      e.preventDefault();
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: this.$elem.offset().top,
        },
        300,
      );
    });
    this.loadProviders();
  }

  pushState() {
    let params = this.$form.serializeJSON();
    params.filters = omitBy(params.filters, (value) => value === "");
    if (Object.keys(params.filters).length === 0) {
      delete params.filters;
    }
    delete params["CRAFT_CSRF_TOKEN"];
    delete params["action"];
    let url = new URL(window.location);
    window.history.pushState({}, "", url.origin + url.pathname + "?" + $.param(params));
  }

  loadProviders(updateUrl = true, checkFilters = true, incremental = false) {
    this.$noFilters.hide();
    if (checkFilters && !this.hasFilters()) {
      this.$noFilters.removeClass("hidden");
      return;
    }
    if (incremental) {
      this.page++;
    } else {
      this.page = 1;
      this.$list.html("");
    }
    this.$loader.removeClass("hidden");
    this.$loadMoreButton.attr("disabled", true);
    this.$noResults.addClass("hidden");
    this.$searchError.addClass("hidden");
    if (updateUrl) {
      this.pushState();
    }
    $.ajax({
      method: "post",
      url: Craft.currentSite.baseUrl,
      data: this.$form.serialize() + "&page=" + this.page,
      headers: {
        "X-CSRF-Token": Craft.csrfToken,
      },
    })
      .done((data) => {
        let html = $(data.html);
        if (incremental) {
          this.$list.append(html);
        } else {
          this.$list.html(html);
        }
        this.initResults(html);
        if (data.hasMore) {
          this.$loadMoreButton.removeClass("hidden");
        } else {
          this.$loadMoreButton.addClass("hidden");
        }
        if (data.count == 0) {
          this.$noResults.removeClass("hidden");
          this.$loadMore.addClass("hidden");
        } else {
          this.$loadMore.removeClass("hidden");
        }
      })
      .fail(() => {
        this.$searchError.removeClass("hidden");
      })
      .always(() => {
        this.$loader.addClass("hidden");
        this.$loadMoreButton.removeAttr("disabled");
      });
  }

  initResults($html) {
    App.tooltips.init($html.find(".js-tooltip"));
    this.providerWebsites.init($html);
  }

  resetForm() {
    this.$form.find("input[name=term]").val("");
    $.each(this.$elem.find("select[multiple]"), (i, select) => {
      $(select).multipleSelect("uncheckAll");
    });
    this.$elem.find("select:not([multiple])").multipleSelect("setSelects", [""]);
  }

  hasFilters() {
    if (this.$form.find("input[name=term]").val().trim().length) {
      return true;
    }
    let hasSelect = false;
    $.each(this.$form.find("select"), (i, select) => {
      if ($(select).val().length) {
        hasSelect = true;
        return false;
      }
    });
    return hasSelect;
  }
}
